<div class="toast-container" [class]="'toast-' + data.type">
  <div class="toast-body">
    <span class="toast-icon">
      <app-icon [name]="typeIcon" [size]="20" aria-hidden="true" />
    </span>

    <div class="toast-text">
      <div class="toast-title">{{ data.title }}</div>
      @if (data.message) {
        <div class="toast-message">{{ data.message }}</div>
      }
    </div>

    <button class="toast-close" (click)="dismiss()" aria-label="Dismiss notification">
      <app-icon name="close" [size]="16" aria-hidden="true" />
    </button>
  </div>

  <div class="toast-progress-track">
    <div class="toast-progress-bar" [style.width.%]="progress()"></div>
  </div>
</div>
